/**
 * AES 加解密 工具类
 */
import CryptoJS from 'crypto-js';
/**
 * @FunctionName: AES 加密
 * @param {*} word   加密的字符串
 * @param {*} secretKey 公钥，默认空取配置的 process.env.VUE_APP_AES_KEY
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 10:23:03
 * @Modification history: 
 * @Description: 
 */
export function encryptAES(word, secretKey) {
  let key = CryptoJS.enc.Utf8.parse(secretKey || process.env.VUE_APP_AES_KEY);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return encrypted.toString();
}

/**
 * @FunctionName: AES 解密
 * @param {*} word  解密的字符串
 * @param {*} secretKey  公钥
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 10:22:38
 * @Modification history: 
 * @Description: 
 */
export function decryptAES(word, secretKey) {
  let key = CryptoJS.enc.Utf8.parse(secretKey || process.env.VUE_APP_AES_KEY);
  let decrypted = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return CryptoJS.enc.Utf8.stringify(decrypted).toString();
}
